<div class="page">

    <section class="section-account parallax bg-11" style="background-image:url(assets/images/header-1.jpg)">
        <div class="awe-overlay"></div>
        <div class="container">
            <div class="login-register">
                <div>
                    <form class="account_form">
                        <h2 class="text text-center">FORGOT PASSWORD</h2>
                        <fieldset>
                            <legend>

                                <p>
                                    An email has been sent to you to reset your password.
                                </p>

                                <div class="field-form field-submit">
                                    <button [routerLink]="['/login']" class="awe-btn awe-btn-13">Go to Login</button>
                                </div>
                            </legend>
                        </fieldset>
                    </form>
                </div>
            </div>
        </div>
    </section>

</div>


// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/core/components/send-confirm/send-confirm.component.html